<div class="w-[1200px]">
  <h2 class="font-semibold mb-4 text-lg">Загрузить файл</h2>
  <div class="flex gap-x-2 mb-2">
    <div class="w-3/12">
      <app-autocomplete
        label="Код покупателя"
        [strict]="false"
        [labelOutside]="false"
        [formControl]="preOrderForm.controls.buyerCode"
        [items]="catalogs.buyers$ | async"
        [itemSearch]="'search'"
        [itemValue]="'code'"
        [displayValue]="'code'"
        [itemText]="'code'"
      ></app-autocomplete>
    </div>
    @if (isImported) {
      <div class="w-4/12">
        <tui-input
          [formControl]="preOrderForm.controls.airWaybillNumber"
          tuiTextfieldSize="m"
          >AWB</tui-input
        >
      </div>
    }
  </div>
  <div class="flex gap-x-2 mb-4">
    <app-autocomplete
      class="w-2/12"
      [formControl]="preOrderForm.controls.farmBrokerJson.controls.id"
      [items]="catalogs.brokerFarms$ | async"
      [itemText]="'name'"
      [itemValue]="'id'"
      [displayValue]="'name'"
      [itemSearch]="'search'"
      label="Питомник посредник"
      [labelOutside]="false"
    ></app-autocomplete>
    <app-autocomplete
      label="Посредник"
      [labelOutside]="false"
      class="w-2/12"
      [formControl]="preOrderForm.controls.brokerJson.controls.id"
      [items]="sellers$ | async"
      [itemValue]="'id'"
      [itemText]="'name'"
      [displayValue]="'name'"
      [itemSearch]="'search'"
    >
    </app-autocomplete>
    <div class="w-[140px] flex items-center">
      <tui-toggle
        [formControl]="preOrderForm.controls.prepayment"
        size="m"
        class="mx-2"
      ></tui-toggle>
      <span class="text-sm">Предоплата</span>
    </div>
    <tui-input-number
      class="w-1/12"
      [precision]="2"
      [formControl]="preOrderForm.controls.prepaymentSum"
      tuiTextfieldSize="m"
      >Сумма</tui-input-number
    >
    <app-autocomplete
      class="w-1/12"
      label="Валюта"
      [labelOutside]="false"
      [itemValue]="'letterCode'"
      [itemText]="'name'"
      [items]="CURRENCIES"
      [formControl]="preOrderForm.controls.prepaymentCurrencyLetter"
    ></app-autocomplete>
    <div class="w-[140px]">
      <app-input-date
        [formControl]="preOrderForm.controls.paymentDate"
        label="Дата платежа"
        [labelOutside]="false"
      ></app-input-date>
    </div>
    <div class="w-[140px]">
      <app-input-date
        [labelOutside]="false"
        [formControl]="preOrderForm.controls.expectedLoadingDate"
        label="Дата загрузки (оритент.)"
      ></app-input-date>
    </div>
  </div>
  <div>
    @for (file of attachments$ | async; track $index) {
      <div class="flex gap-x-2 bg-neutral-100 mb-2 rounded-xl p-2 items-center">
        <div class="font-bold">{{ $index + 1 }}</div>
        <div>{{ file.name }}</div>
        <div>{{ roundDecimal(file.length / (1024 * 1024)) }}Мб</div>
        <div class="mr-0 ml-auto flex justify-end">
          <button
            (click)="openFileInNewTab$.next(file.name)"
            size="s"
            tuiIconButton
            icon="tuiIconFileText"
          ></button>
        </div>
      </div>
    }
  </div>
  <div class="my-2">
    <app-files-input
      [accept]="
        [
          mimeTypes.APPLICATION_PDF,
          mimeTypes.IMAGE,
          mimeTypes.EXCEL,
          mimeTypes.EXCEL_OLD,
          mimeTypes.DOCX,
          mimeTypes.DOC
        ].join()
      "
      [formControl]="files"
    ></app-files-input>
  </div>

  <div class="flex gap-x-2">
    <button
      [disabled]="!canEdit"
      tuiButton
      size="m"
      (click)="saveChanges$.next({ close: true })"
    >
      Сохранить
    </button>
    <button
      [disabled]="!(attachments$ | async)?.length"
      appearance="outline"
      tuiButton
      size="m"
      icon="tuiIconDownload"
      (click)="download$.next()"
    >
      Скачать архив
    </button>
    <button
      class="ml-auto mr-0"
      [disabled]="canRemove ? !(attachments$ | async)?.length : true"
      appearance="secondary-destructive"
      tuiButton
      icon="tuiIconTrash"
      size="m"
      (click)="delete$.next()"
    >
      Удалить архив
    </button>
  </div>
</div>
